import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { emailValidator } from '@uc/web/core';
import { CloseModalComponent, FormErrorComponent } from '@uc/shared/ui';
import { InputFieldComponent } from '@uc/web/shared/form-elements';
import { ReportFeedbackComponent } from './report-feedback/report-feedback.component';
import { ReportModalApiService } from '../../../data-access/services/report-modal-api.service';

@Component({
	selector: 'uc-report-modal',
	templateUrl: './report-modal.component.html',
	imports: [
		NgClass,
		ReactiveFormsModule,
		CloseModalComponent,
		ReportFeedbackComponent,
		InputFieldComponent,
		FormErrorComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportModalComponent implements OnDestroy, OnInit {
	formError!: boolean;
	reportFeedback!: string;
	formSubmitted = false;
	formSuccess = false;
	reportForm!: FormGroup;
	formErrorsText!: string;

	private _submitReportSub!: Subscription;

	constructor(
		private _reportApiSrv: ReportModalApiService,
		private _cd: ChangeDetectorRef,
	) {}

	ngOnInit(): void {
		this.reportForm = new FormGroup({
			email: new FormControl('', [Validators.required, emailValidator]),
			message: new FormControl('', [Validators.required]),
		});
	}

	onSubmitReport() {
		this.formSubmitted = true;

		if (this.reportForm.invalid) {
			return;
		} else {
			this._submitReportSub = this._reportApiSrv
				.submitReport(this.reportForm.value)
				.subscribe({
					next: (response: { message: string }) => {
						if (response?.message === 'Review reported successfully') {
							//handle success
							this.formError = false;
							this.reportFeedback =
								'Thank you for your message. We will look into this review.';
							this.formSuccess = true;
						}

						this._cd.detectChanges();
					},
					error: (error: HttpErrorResponse) => {
						if (
							error.error.message.includes(
								'was already reported by student with email',
							)
						) {
							//handle user trying to submit report again.
							this.formError = true;
							this.reportFeedback =
								'You already reported this review before.';
							this.formSuccess = true;
						} else if (
							error.error.message.includes('is not a valid email address')
						) {
							this.reportForm
								.get('email')
								?.setErrors({ emailInvalid: true });
							this.formSuccess = false;
						}

						this._cd.detectChanges();
					},
				});
		}
	}

	ngOnDestroy(): void {
		this._submitReportSub?.unsubscribe();
	}
}
